import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { acceptInvitation, listMyInvitations } from '../../lib/callables';

export function useMyInvitations() {
  return useQuery({
    queryKey: ['my-invitations'],
    queryFn: listMyInvitations,
  });
}

export function useAcceptInvitation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: acceptInvitation,
    onSuccess: async (result) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['cases'] }),
        queryClient.invalidateQueries({ queryKey: ['my-invitations'] }),
        queryClient.invalidateQueries({ queryKey: ['case-members', result.caseId] }),
      ]);
    },
  });
}
